<template >
  <div class="frame" :class="{ frame_: insideFrame }">
    <div class="title" :class="{ type_same_line: typeSameLine }">
      <div class="left_area">
        <div v-if="title" class="left_icon" :style="'color:' + color">▋</div>
        {{ title }}
      </div>
      <div class="right_area">
        <slot name="headerSlot" />
      </div>
    </div>
    <div class="content">
      <slot name="contentSlot" />
    </div>
  </div>
</template>

<script >
export default {
  name: "frame",
  props: {
    title: {
      type: String,
      default: "标题",
    },
    color: {
      type: String,
      default: "",
    },
    insideFrame: {
      type: Boolean,
      default: false,
    },
    typeSameLine: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>

.frame {
  padding-top: 10px;
  padding-left: 10px;
  position: relative;
  background-color: #fff;
  border: 1px solid #e9e9e9 ;
  border-radius: 10px;
  box-shadow: rgba(0, 0, 0, 0.047) 0px 0px 10px;
  .title {
    display: flex;
    height: 40px;
    justify-content: space-between;
    align-items: center;
    .left_area {
      position: relative;

      font-weight: 700;
      // font-size: 13px;
      color: #666666;
      display: flex;
      align-items: center;
      .left_icon {
        padding-right: 5px;
        font-weight: 400;
        font-size: 13px;
        color: #409eff;
      }
    }
    // &::before {
    //   position: absolute;
    //   content: "";
    //   width: 20px;
    //   height: 20px;
    //   background: #547dfb;
    //   box-shadow: -3px 0px 8px 3px rgba(83, 125, 251, 0.61);
    //   top: 50%;
    //   left: 0;
    //   transform: translateY(-50%);
    //   border-radius: 50%;
    // }

    .right_area {
      padding-right: 20px;
    }
  }
  .content {
  }
}
.frame_ {
  border:none;
  border-color:none;
  border-radius:none;
  box-shadow:none;
  padding-left:0;
}

  .type_same_line {
    position: absolute;
    z-index: 2;
    top: 6px;
  }
</style>